import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const TaskDeleteModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    currentTask, deleteModal, submitted,
    // event handlers
    onSubmit, onCancel,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_delete_task'
    buttonMessageKey='c_delete'
    cancelMessageKey='c_cancel'

    isOpen={deleteModal}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onRequestClose={onCancel}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <MessageUI messageList={messageList} messageKey='c_delete_task_confirm'
    />
  </ModalFormUI>

export default TaskDeleteModalUI
